// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W274R","colBig":"styles_colBig__1sBx7","colSmall":"styles_colSmall__3D_R9"};